// const API = 'http://localhost:8080/api';
// const API = 'http://35.182.240.208:8080/api'
const API = 'https://api.safesportforyouth.org/api'

// const API = 'https://safesport-backend.onrender.com/api'

export {API}